module.exports = __webpack_public_path__ + "img/police-station.a453cbd8.webp";